import { ChangeEvent, FC, ReactNode, Ref } from 'react';
import clsx from 'clsx';
import { AText } from '../AText';
import { Box } from '../Box';
import { Label } from '../Label';

import styles from './index.module.css';

type Size = 's' | 'm';

interface RadioClassNames {
  wrapperClassName?: string;
  labelTextClassName?: string;
  inputClassName?: string;
  radioClassName?: string;
  activeLabelClassName?: string;
  activeLabelTextClassName?: string;
}

export interface RadioProps {
  label?: ReactNode;
  inputRef?: Ref<HTMLInputElement>;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  disabled?: boolean;
  size?: Size;
  name?: string;
  className?: string;
  classNames?: RadioClassNames;
  dataRole?: string;
  isActive?: boolean;
  checked?: boolean;
}

export const Radio: FC<RadioProps> = ({
  label = '',
  inputRef = null,
  onChange = () => {},
  value = '',
  disabled = false,
  size = 's',
  name = '',
  className,
  classNames = {},
  dataRole,
  isActive,
  ...props
}) => {
  const {
    wrapperClassName = '',
    labelTextClassName = '',
    inputClassName = '',
    radioClassName = '',
    activeLabelClassName = '',
    activeLabelTextClassName = ''
  } = classNames;
  const classes = clsx(
    styles.wrapper,
    className,
    wrapperClassName,
    styles[size],
    disabled && styles.disabled,
    isActive && activeLabelClassName
  );

  return (
    <Label className={classes}>
      <Box data-role={dataRole && `${dataRole}-input`}>
        <input
          ref={inputRef}
          type="radio"
          className={`${styles.input} ${inputClassName}`}
          value={value}
          onChange={onChange}
          name={name}
          disabled={disabled}
          {...props}
        />
        <Box
          className={`${styles.radio} ${radioClassName}`}
          align="center"
          justify="center"
        />
      </Box>
      {label && (
        <AText
          data-role={dataRole && `${dataRole}-label`}
          className={clsx([
            styles.label,
            labelTextClassName,
            isActive && activeLabelTextClassName
          ])}
          color="txt_color_7"
          size={size}
        >
          {label}
        </AText>
      )}
    </Label>
  );
};
